import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellocalfcss/Student-statment-report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

const Student_statement_Report = () => {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [reportData, setReportData] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [studentId, setStudentId] = useState("");
  const [startDate, setStartDate] = useState("2017-01-01");
  const [endDate, setEndDate] = useState("2026-12-31");

  const commonPayload = {
    customer_id: Number(localStorage.getItem("customer_id")) || 1005,
    api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
    language: "en",
    user_id: localStorage.getItem("user_id") || 14857,
    page: 1,
    limit: 999,
  };

  useEffect(() => {
    const fetchStudentList = async () => {
      try {
        const payload = {
          ...commonPayload,
          student_id: studentId || 58,
          start_date: startDate,
          end_date: endDate,
        };
        const response = await simplePostCall(
          ApiConfig.studentpaymentsRports,
          JSON.stringify(payload)
        );
        if (response?.result && Array.isArray(response.studentSelect) && response.studentSelect.length > 0) {
          setStudentList(response.studentSelect);
          setStudentId(response.studentSelect[0].student_id);
        }
      } catch (error) {
        console.error("Error fetching student list:", error);
      }
    };
    fetchStudentList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchReportData = useCallback(async () => {
    if (!studentId) return;
    setLoading(true);
    try {
      const payload = {
        ...commonPayload,
        student_id: studentId || 58,
        start_date: startDate,
        end_date: endDate,
      };
      const response = await simplePostCall(
        ApiConfig.studentpaymentsRports,
        JSON.stringify(payload)
      );
      if (response?.result && Array.isArray(response.data)) {
        setReportData(response.data);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  }, [studentId, startDate, endDate]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchReportData();
  }, [fetchReportData]);

  const totalAmount = reportData.reduce((sum, item) => sum + Number(item.amount || 0), 0);

  const handleClear = () => {
    setStartDate("2017-01-01");
    setEndDate("2026-12-31");
  };

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Student Statement Report</h4>
        <button className="btn btn-sm btn-primary">Export</button>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select
            className="form-select"
            value={studentId}
            onChange={(e) => setStudentId(e.target.value)}
          >
            <option value="">-- Select Student --</option>
            {studentList.map((student) => (
              <option key={student.student_id} value={student.student_id}>
                {student.student_name}
              </option>
            ))}
          </select>

          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <span className="yc-filter-label">to</span>
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <button className="btn btn-primary" onClick={handleClear}>
            Clear
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-5">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Date</div>
            <div className="yc-list-cell">Fee Type</div>
            <div className="yc-list-cell">Payment Mode</div>
            <div className="yc-list-cell">Amount Paid</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : reportData.length > 0 ? (
          <>
            <div className="yc-list-row-list">
              {reportData.map((item, index) => (
                <div key={index} className="yc-list-row-card">
                  <div className="yc-list-grid yc-list-grid-5">
                    <div className="yc-list-cell">{index + 1}</div>
                    <div className="yc-list-cell">{item.date}</div>
                    <div className="yc-list-cell">{item.category_name}</div>
                    <div className="yc-list-cell">{item.payment_mode.replace(/_/g, " ")}</div>
                    <div className="yc-list-cell">{customer_currency} {formatNumber(item.amount)}</div>
                  </div>
                </div>
              ))}
              <div className="yc-list-row-card yc-list-row-total">
                <div className="yc-list-grid yc-list-grid-5">
                  <div className="yc-list-cell"></div>
                  <div className="yc-list-cell"></div>
                  <div className="yc-list-cell"></div>
                  <div className="yc-list-cell fw-bold">Total Paid</div>
                  <div className="yc-list-cell yc-amount-positive">
                    {customer_currency} {formatNumber(totalAmount)}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="yc-empty-state">No records found.</div>
        )}
      </div>
    </div>
  );
};

export default Student_statement_Report;
